<style>
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    width: 407px;
    height: 53px;
    border-radius: var(--corner-16, 16px);
    background: var(--material-theme-ref-secondary-secondary-98, #fcf8ff);
  }

  button {
    display: flex;
    width: 151px;
    padding: 8px 24px;
    justify-content: center;
    align-items: center;
    gap: 16px;
    border-radius: 40px;
    background: var(--material-theme-sys-light-primary, #5b43d9);
    color: var(--material-theme-sys-light-on-primary, #fff);
    text-align: center;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.32px;
    border: none;
  }
</style>
<div
  class="container-title"
  style="
    display: flex;
    width: 500px;
    padding: 15px 0px 15px 0px;
    align-items: center;
    gap: 15px;
  "
>
  <img src="assets/icons/gear.svg" alt="" />

  <h2
    style="
      color: var(--material-theme-ref-primary-primary-10, #180064);
      font-family: Roboto;
      font-size: 22px;
      font-style: normal;
      font-weight: 500;
      margin: 0;
      line-height: 28px;
    "
    mat-dialog-title
  >
    Personalizar análise de casos
  </h2>
</div>
<ul class="draggable-list">
  <div
    style="display: flex; align-items: center; gap: 15px; margin-top: 15px"
    *ngFor="let item of items; let i = index"
    draggable="true"
    (dragstart)="onDragStart(i)"
    (dragover)="onDragOver($event)"
    (drop)="onDrop(i)"
  >
    <img src="assets/icons/draggable.svg" alt="" />

    <li
      style="
        display: flex;
        align-items: center;
        padding-left: 30px;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        color: var(--material-theme-ref-neutral-neutral-20, #323033);
      "
      class="li-{{retirarEspacos(item)}}"
    >
      {{ item }}
    </li>
  </div>
</ul>
<div style="justify-content: center; padding: 30px" mat-dialog-actions>
  <button (click)="onNoClick()">Salvar</button>
</div>
